export default "__VITE_ASSET__BCfRIl9M__"